module.exports = __webpack_public_path__ + "./images/cca0e5366abda7e7ea91f3a741b224b1.webp";